import React from "react";
import { Globe, Check } from "lucide-react";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useI18n } from "@/lib/i18n";

const LANGS = [
    { code: "de", label: "Deutsch", flag: "DE" },
    { code: "en", label: "English", flag: "EN" },
    { code: "fr", label: "Français", flag: "FR" },
    { code: "es", label: "Español", flag: "ES" },
];

export default function LanguagePicker({ variant = "default", testid = "lang-picker" }) {
    const { t, lang, setLang } = useI18n();

    const triggerCls = variant === "onColor"
        ? "text-xs font-mono uppercase tracking-widest text-white/80 hover:text-white border border-white/20 rounded-md px-2.5 py-1 flex items-center gap-1.5"
        : "text-xs font-mono uppercase tracking-widest text-gray-500 hover:text-[#00153f] px-2 py-1 flex items-center gap-1.5 rounded-md";

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button data-testid={testid} className={triggerCls} aria-label={t("nav_lang_label")}>
                    <Globe className="w-3.5 h-3.5" />
                    {lang.toUpperCase()}
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-[160px]">
                {LANGS.map((l) => (
                    <DropdownMenuItem
                        key={l.code}
                        data-testid={`${testid}-opt-${l.code}`}
                        onSelect={() => setLang(l.code)}
                        className="cursor-pointer flex items-center justify-between"
                    >
                        <span className="flex items-center gap-2">
                            <span className="text-xs font-mono text-gray-400 w-5">{l.flag}</span>
                            <span className="text-sm text-[#00153f]">{l.label}</span>
                        </span>
                        {lang === l.code && <Check className="w-3.5 h-3.5 text-[#0b905d]" />}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
